import * as React from 'react';
import {registerLocale, setDefaultLocale} from 'react-datepicker';
import {connect, ConnectedProps} from 'react-redux';

import DateUtils from 'src/js/common/utils/date_utils';
import {I18N_REDUCER_STATE_ID} from 'src/js/containers/i18n/i18n_constants';
import {I18nConfigRaw} from 'src/js/model/i18n_config';
import {RootState} from 'src/js/store';

interface OwnProps {
  children: React.ReactNode;
}

const mapState = (state: RootState) => ({
  i18nConfig: state[I18N_REDUCER_STATE_ID].i18nConfig,
  currentLocale: state[I18N_REDUCER_STATE_ID].currentLocale,
});

const connector = connect(mapState);
type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & OwnProps;

class DatePickerLocaleProviderContainer extends React.PureComponent<Props> {
  /* eslint-disable import/no-dynamic-require, global-require */
  static registerLocaleData(i18nConfig?: I18nConfigRaw) {
    const localesData = DateUtils.loadLocaleData(i18nConfig);
    Object.keys(localesData).forEach((locale) => {
      registerLocale(locale, localesData[locale]);
    });
  }

  /* eslint-enable import/no-dynamic-require, global-require */
  static displayName = 'DatePickerLocaleProviderContainer';

  constructor(props) {
    super(props);
    const {currentLocale, i18nConfig} = this.props;

    DatePickerLocaleProviderContainer.registerLocaleData(i18nConfig);
    setDefaultLocale(currentLocale);
  }

  componentDidUpdate(prevProps) {
    const {currentLocale} = this.props;
    if (currentLocale && currentLocale !== prevProps.currentLocale) {
      setDefaultLocale(currentLocale);
    }
  }

  render() {
    const {children} = this.props;
    return children;
  }
}

export default connector(DatePickerLocaleProviderContainer);
